import { MoreMenuIconButton, type MoreMenuIconButtonOption } from '@shared/components';

export default function ExamSessionExamineeMonitorMoreActionMenu() {
  // REMARK: Options will be implemented with "add more time" and "stop exam" features
  const options: MoreMenuIconButtonOption[] = [];

  const shouldDisabled = options.length === 0;

  return (
    <MoreMenuIconButton
      options={options}
      slotProps={{
        iconButton: {
          disabled: shouldDisabled,
        },
      }}
    />
  );
}
